import * as React from 'react'
import { useMemo } from 'react'
import useAppTilesNested from '../shared-hooks/useAppTilesNested'
import useBalance from '../shared-hooks/useBalance'

export const HomeContext = React.createContext({
  banners: {} as string,
  bannersLoading: {},
  selectedTiles: {},
  appTilesLoading: false,
  tiles: [],
  floatingBarTiles: [],
  setSelectedTiles: (key: any) => {},
  balance: null,
  fetchBalance: () => {},
  BalanceCText: React.Component,
  balanceData: {},
  loadingBalance: false,
})

const HomeContextProvider = ({ children }: any) => {
  // const { tiles, appTilesLoading} = useAppTiles();
  const { tiles, appTilesLoading, floatingBarTiles } = useAppTilesNested()
  const { balance, fetchBalance, BalanceCText, balanceData, loadingBalance } =
    useBalance()

  const selectedTiles = useMemo(() => {
    return {
      grocery: tiles?.find((item: any) => item?.title === ''),
      nomand: tiles?.find((item: any) => item?.title === ''),
      ticket: tiles?.find((item: any) => item?.title === 'بلیت الکترونیک'),
      taxi: tiles?.find((item: any) => item?.title === 'کرایه تاکسی'),
      trafficPlan: tiles?.find((item: any) => item?.title === 'طرح ترافیک'),
    }
  }, [tiles])

  const homeContext = {
    selectedTiles: selectedTiles,
    tiles: tiles,
    floatingBarTiles: floatingBarTiles,
    appTilesLoading: appTilesLoading,
    balance,
    fetchBalance,
    BalanceCText,
    balanceData,
    loadingBalance,
  }

  return (
    <HomeContext.Provider value={homeContext}>{children}</HomeContext.Provider>
  )
}

export default HomeContextProvider
